<app-navigation></app-navigation>
<section>
  <router-outlet></router-outlet>
</section>
<app-footer></app-footer>